var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('h1',[_vm._v("e404")]),_c('br'),_c('a',{on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('general.back')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }